const PlaceAddress = ({
  formatted,
  components
}) => ({
  formatted,
  components
});

export default PlaceAddress;
